/* global System */

export default {
  UserProfile: () =>
    System.import(/* webpackChunkName: "UserProfile" */ './index'),
}
